// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const relatedPropertiesSwiperArray = document.querySelectorAll('.swiper--related-properties__homepage--land')

if (relatedPropertiesSwiperArray) {

  relatedPropertiesSwiperArray.forEach((relatedPropertiesSwiper) => {
    // count number of slides to fix loop bug
    var slidesCount = relatedPropertiesSwiper.getElementsByClassName('swiper-slide').length;

    // init Swiper:
    const swiper = new Swiper('.swiper--related-properties__homepage--residential', {
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 15,
      breakpoints : {
        768 : {
          slidesPerView: 2,
        }
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });

  })
}

